import { Table } from "antd";
import styled from "styled-components";
import { color } from "../../resource";

export const AntTable = styled(Table)`
  .ant-table-cell,
  .ant-table-title {
    font-family: "IBM Plex Sans Thai", sans-serif;
    font-weight: 700 !important;
    font-size: 16px;
    color: ${color.Text1};
    border-radius: 0px !important;
  }
  .ant-table-thead > tr > th,
  .ant-table-title {
    font-weight: 700 !important;
    font-size: 16px;
    color: ${color.Text1};
    background-color: ${color.background1};
    border-bottom: 0px;
    padding: 12px 16px;
  }
  .ant-table-expanded-row > td {
    padding-left: 40px !important;
  }

  .ant-table-row-expand-icon-cell {
    padding-left: 16px !important;
  }
`;
export const CardRole = styled.div`
  border-left: 1px solid ${color.background1};
  border-right: 1px solid ${color.background1};
`;

export interface RoleRecord {
  menuName: string;
  groupName: string;
  isNested: boolean;
  list: Array<{
    label: string;
    value: string;
    listNested?: Array<{ label: string; value: string }>;
  }>;
  groupNameNested?: string;
}
